export const sidebarActionsTypes = {
  DEFAULT: "default",
  SIDEBAR_IS_HOVERED: "sidebarIsHovered",
  SIDEBAR_RESET: "sidebarReset",
  SIDEBAR_SELECTED_BUTTON: "sidebarSelectedButton",
} as const;

export const SIDEBAR_BUTTON_HOME = "sidebar home";
